import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OutdatedConfigVersionComponent } from "./errorModals/outdatedVersion/outdated-version.component";
import { DocumentVersionErrorModalComponent } from "./errorModals/documentVersion/document-version-error-modal.component";
import { GenericErrorModalComponent } from "./errorModals/genericError/generic-error-modal.component";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { AnimationModule } from "../../shared/components/animation/animation.module";
import { AppSaysoPreviewModule } from "../../shared/components/saysoPreview/appTopicsListPreview/app-sayso-preview.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { SaysoColorPickerModule } from "./color-picker/sayso-color-picker.module";
import { TestInstallationModule } from "./installation/testInstallation/test-installation.module";
import { SaysoSettingsComponent } from "./sayso-settings.component";
import { SaysoPricingModalComponent } from "./saysoPricing/saysoPricingModal/sayso-pricing-modal.component";
import { SaysoSettingsRoutingModule } from "./saysoSettingsRouting.module";
import { TopicListModule } from "./topicList/topic-list.module";

@NgModule({
  declarations: [
    SaysoSettingsComponent,
    SaysoPricingModalComponent,
    OutdatedConfigVersionComponent,
    DocumentVersionErrorModalComponent,
    GenericErrorModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    SaysoColorPickerModule,
    MaterialModule,
    FormsModule,
    AnimationModule,
    AppSaysoPreviewModule,
    TranslateModule,
    TestInstallationModule,
    TopicListModule,
    SaysoSettingsRoutingModule
  ]
})
export class SaysoSettingsModule {}
